import { useEffect, useMemo, useState } from "react";

type Props = {
  aberto: boolean;
  onClose: () => void;
  comissaoPercentual?: number;
  onAplicar?: (valorCobrar: string) => void;  // ← volta para string
};

function toNumber(valor: number | string | undefined): number {
  if (valor === undefined || valor === null || valor === "") return 0;
  if (typeof valor === "number") return valor;

  const texto = String(valor).trim();

  // aceita "100,50" e "100.50"
  const normalizado = texto.includes(",")
    ? texto.replace(/\./g, "").replace(",", ".")
    : texto;

  const numero = parseFloat(normalizado);
  return Number.isFinite(numero) ? numero : 0;
}

function formatarMoeda(valor: number): string {
  return valor.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
}

export default function CalculadoraTaxaModal({
  aberto,
  onClose,
  comissaoPercentual = 25,
  onAplicar,
}: Props) {
  const [valorLiquidoDesejado, setValorLiquidoDesejado] = useState("");

  useEffect(() => {
    if (aberto) {
      setValorLiquidoDesejado("");
    }
  }, [aberto]);

    const valorCobrar = useMemo(() => {
        const liquido = toNumber(valorLiquidoDesejado);
        const comissao = comissaoPercentual / 100;
        if (liquido <= 0) return 0;
        const divisor = 1 - comissao;
        const bruto = divisor > 0 ? liquido / divisor : 0;
        return Math.ceil(bruto / 5) * 5;  // arredonda para cima até múltiplo de 5
    }, [valorLiquidoDesejado, comissaoPercentual]);

  if (!aberto) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-end justify-center bg-black/40 sm:items-center">
      <div className="w-full max-w-md rounded-t-2xl bg-white p-4 shadow-xl sm:rounded-2xl">
        <div className="mb-4 flex items-center justify-between">
          <h3 className="text-lg font-semibold">Calculadora de preço</h3>
          <button
            type="button"
            onClick={onClose}
            className="rounded-md px-3 py-1 text-sm hover:bg-gray-100"
          >
            Fechar
          </button>
        </div>

        <div className="space-y-4">
          <div>
            <label className="mb-1 block text-sm font-medium">
              Quanto eu quero receber líquido
            </label>
            <input
              type="number"
              min="0"
              step="0.01"
              value={valorLiquidoDesejado}
              onChange={(e) => setValorLiquidoDesejado(e.target.value)}
              className="w-full rounded-lg border px-3 py-2"
              placeholder="0,00"
            />
          </div>

          <div className="rounded-xl border bg-gray-50 p-4">
            <div className="text-sm text-gray-600">Quanto eu tenho que cobrar</div>
            <div className="mt-1 text-2xl font-bold text-emerald-700">
              {formatarMoeda(valorCobrar)}
            </div>
          </div>

            <button
                type="button"
                onClick={() => {
                    onAplicar?.(
                        valorCobrar.toLocaleString("pt-BR", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                        })
                    );
                    onClose();
                }}
                className="w-full rounded-lg bg-emerald-600 px-4 py-2 font-medium text-white hover:bg-emerald-700"
                >
                Usar esse valor
            </button>
        </div>
      </div>
    </div>
  );
}